import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface DeliveryPickupChartProps {
  deliveryCount: number;
  pickupCount: number;
  prevDeliveryCount?: number;
  prevPickupCount?: number;
}
export function DeliveryPickupChart({
  deliveryCount,
  pickupCount,
  prevDeliveryCount,
  prevPickupCount
}: DeliveryPickupChartProps) {
  const total = deliveryCount + pickupCount;
  const deliveryPercentage = Math.round(deliveryCount / total * 100);
  const pickupPercentage = 100 - deliveryPercentage;
  const deliveryChange = prevDeliveryCount && prevDeliveryCount > 0 ? Math.round((deliveryCount - prevDeliveryCount) / prevDeliveryCount * 100) : null;
  const pickupChange = prevPickupCount && prevPickupCount > 0 ? Math.round((pickupCount - prevPickupCount) / prevPickupCount * 100) : null;
  // Calculate circle properties for SVG
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const deliveryOffset = circumference - deliveryPercentage / 100 * circumference;
  return <Card className="h-full" data-id="element-32">
      <CardHeader data-id="element-33">
        <CardTitle className="text-base font-semibold" data-id="element-34">
          Delivery vs Pickup
        </CardTitle>
      </CardHeader>
      <CardContent data-id="element-35">
        <div className="flex flex-col items-center justify-center py-4" data-id="element-36">
          <div className="relative w-48 h-48" data-id="element-37">
            {/* SVG Donut Chart */}
            <svg className="w-full h-full transform -rotate-90" data-id="element-38">
              {/* Background Circle (Pickup - Slate) */}
              <circle cx="50%" cy="50%" r={radius} fill="transparent" stroke="#f1f5f9" strokeWidth="20" data-id="element-39" />
              {/* Foreground Circle (Delivery - Teal) */}
              <motion.circle cx="50%" cy="50%" r={radius} fill="transparent" stroke="#0d9488" strokeWidth="20" strokeDasharray={circumference} initial={{
              strokeDashoffset: circumference
            }} animate={{
              strokeDashoffset: deliveryOffset
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} strokeLinecap="round" data-id="element-40" />
            </svg>
            {/* Center Text */}
            <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-41">
              <span className="text-3xl font-bold text-slate-900" data-id="element-42">
                {total.toLocaleString()}
              </span>
              <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider" data-id="element-43">
                Total Orders
              </span>
            </div>
          </div>

          {/* Legend / Stats */}
          <div className="grid grid-cols-2 gap-8 mt-8 w-full px-4" data-id="element-44">
            <div className="flex flex-col items-center" data-id="element-45">
              <div className="flex items-center gap-2 mb-1" data-id="element-46">
                <div className="w-2.5 h-2.5 rounded-full bg-teal-600" data-id="element-47" />
                <span className="text-xs font-bold text-slate-500 uppercase tracking-tight" data-id="element-48">
                  Delivery
                </span>
              </div>
              <div className="flex items-baseline gap-1" data-id="element-49">
                <span className="text-xl font-bold text-slate-900" data-id="element-50">
                  {deliveryCount.toLocaleString()}
                </span>
                <span className="text-[10px] text-slate-400 font-medium" data-id="element-51">
                  ({deliveryPercentage}%)
                </span>
              </div>
            </div>
            <div className="flex flex-col items-center" data-id="element-52">
              <div className="flex items-center gap-2 mb-1" data-id="element-53">
                <div className="w-2.5 h-2.5 rounded-full bg-slate-200" data-id="element-54" />
                <span className="text-xs font-bold text-slate-500 uppercase tracking-tight" data-id="element-55">
                  Pickup
                </span>
              </div>
              <div className="flex items-baseline gap-1" data-id="element-56">
                <span className="text-xl font-bold text-slate-900" data-id="element-57">
                  {pickupCount.toLocaleString()}
                </span>
                <span className="text-[10px] text-slate-400 font-medium" data-id="element-58">
                  ({pickupPercentage}%)
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}